import React from 'react';
import {Truck} from 'lucide-react';

const DeliveryFormHeader: React.FC = () => {
  return (
    <>
      <h2 className="text-xl font-semibold mb-3 flex items-center gap-2">
        <Truck className="h-5 w-5 text-green-500" />
        توزيع المنتجات للمسوقين
      </h2>
    </>
  );
};

export default DeliveryFormHeader;
